/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as NoAccessRouteImport } from './routes/no-access'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedErrorsRouteImport } from './routes/_authed/errors'
import { Route as AuthedHealthRouteImport } from './routes/_authed/health'
import { Route as AuthActionRouteImport } from './routes/auth/action'
import { Route as AuthedClinicsIndexRouteImport } from './routes/_authed/clinics/index'
import { Route as AuthedClinicsNewRouteImport } from './routes/_authed/clinics/new'
import { Route as AuthedClinicsClinicIdIndexRouteImport } from './routes/_authed/clinics/$clinicId/index'
import { Route as AuthedClinicsClinicIdTabRouteImport } from './routes/_authed/clinics/$clinicId/$tab'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const NoAccessRoute = NoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedErrorsRoute = AuthedErrorsRouteImport.update({
  id: '/errors',
  path: '/errors',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedHealthRoute = AuthedHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthActionRoute = AuthActionRouteImport.update({
  id: '/auth/action',
  path: '/auth/action',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedClinicsIndexRoute = AuthedClinicsIndexRouteImport.update({
  id: '/clinics/',
  path: '/clinics/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedClinicsNewRoute = AuthedClinicsNewRouteImport.update({
  id: '/clinics/new',
  path: '/clinics/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedClinicsClinicIdIndexRoute =
  AuthedClinicsClinicIdIndexRouteImport.update({
    id: '/clinics/$clinicId/',
    path: '/clinics/$clinicId/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedClinicsClinicIdTabRoute =
  AuthedClinicsClinicIdTabRouteImport.update({
    id: '/clinics/$clinicId/$tab',
    path: '/clinics/$clinicId/$tab',
    getParentRoute: () => AuthedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/no-access': typeof NoAccessRoute
  '/set-password': typeof SetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/errors': typeof AuthedErrorsRoute
  '/health': typeof AuthedHealthRoute
  '/auth/action': typeof AuthActionRoute
  '/clinics/new': typeof AuthedClinicsNewRoute
  '/clinics/': typeof AuthedClinicsIndexRoute
  '/clinics/$clinicId/$tab': typeof AuthedClinicsClinicIdTabRoute
  '/clinics/$clinicId/': typeof AuthedClinicsClinicIdIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/no-access': typeof NoAccessRoute
  '/set-password': typeof SetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/errors': typeof AuthedErrorsRoute
  '/health': typeof AuthedHealthRoute
  '/auth/action': typeof AuthActionRoute
  '/': typeof AuthedIndexRoute
  '/clinics/new': typeof AuthedClinicsNewRoute
  '/clinics': typeof AuthedClinicsIndexRoute
  '/clinics/$clinicId/$tab': typeof AuthedClinicsClinicIdTabRoute
  '/clinics/$clinicId': typeof AuthedClinicsClinicIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/no-access': typeof NoAccessRoute
  '/set-password': typeof SetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/_authed/errors': typeof AuthedErrorsRoute
  '/_authed/health': typeof AuthedHealthRoute
  '/auth/action': typeof AuthActionRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/clinics/new': typeof AuthedClinicsNewRoute
  '/_authed/clinics/': typeof AuthedClinicsIndexRoute
  '/_authed/clinics/$clinicId/$tab': typeof AuthedClinicsClinicIdTabRoute
  '/_authed/clinics/$clinicId/': typeof AuthedClinicsClinicIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/no-access'
    | '/set-password'
    | '/sign-in'
    | '/errors'
    | '/health'
    | '/auth/action'
    | '/clinics/new'
    | '/clinics/'
    | '/clinics/$clinicId/$tab'
    | '/clinics/$clinicId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/no-access'
    | '/set-password'
    | '/sign-in'
    | '/errors'
    | '/health'
    | '/auth/action'
    | '/'
    | '/clinics/new'
    | '/clinics'
    | '/clinics/$clinicId/$tab'
    | '/clinics/$clinicId'
  id:
    | '__root__'
    | '/_authed'
    | '/forgot-password'
    | '/no-access'
    | '/set-password'
    | '/sign-in'
    | '/_authed/errors'
    | '/_authed/health'
    | '/auth/action'
    | '/_authed/'
    | '/_authed/clinics/new'
    | '/_authed/clinics/'
    | '/_authed/clinics/$clinicId/$tab'
    | '/_authed/clinics/$clinicId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  NoAccessRoute: typeof NoAccessRoute
  SetPasswordRoute: typeof SetPasswordRoute
  SignInRoute: typeof SignInRoute
  AuthActionRoute: typeof AuthActionRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-access': {
      id: '/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof NoAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/errors': {
      id: '/_authed/errors'
      path: '/errors'
      fullPath: '/errors'
      preLoaderRoute: typeof AuthedErrorsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/health': {
      id: '/_authed/health'
      path: '/health'
      fullPath: '/health'
      preLoaderRoute: typeof AuthedHealthRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/auth/action': {
      id: '/auth/action'
      path: '/auth/action'
      fullPath: '/auth/action'
      preLoaderRoute: typeof AuthActionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/clinics/': {
      id: '/_authed/clinics/'
      path: '/clinics'
      fullPath: '/clinics/'
      preLoaderRoute: typeof AuthedClinicsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/clinics/new': {
      id: '/_authed/clinics/new'
      path: '/clinics/new'
      fullPath: '/clinics/new'
      preLoaderRoute: typeof AuthedClinicsNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/clinics/$clinicId/': {
      id: '/_authed/clinics/$clinicId/'
      path: '/clinics/$clinicId'
      fullPath: '/clinics/$clinicId/'
      preLoaderRoute: typeof AuthedClinicsClinicIdIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/clinics/$clinicId/$tab': {
      id: '/_authed/clinics/$clinicId/$tab'
      path: '/clinics/$clinicId/$tab'
      fullPath: '/clinics/$clinicId/$tab'
      preLoaderRoute: typeof AuthedClinicsClinicIdTabRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedErrorsRoute: typeof AuthedErrorsRoute
  AuthedHealthRoute: typeof AuthedHealthRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedClinicsNewRoute: typeof AuthedClinicsNewRoute
  AuthedClinicsIndexRoute: typeof AuthedClinicsIndexRoute
  AuthedClinicsClinicIdTabRoute: typeof AuthedClinicsClinicIdTabRoute
  AuthedClinicsClinicIdIndexRoute: typeof AuthedClinicsClinicIdIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedErrorsRoute: AuthedErrorsRoute,
  AuthedHealthRoute: AuthedHealthRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedClinicsNewRoute: AuthedClinicsNewRoute,
  AuthedClinicsIndexRoute: AuthedClinicsIndexRoute,
  AuthedClinicsClinicIdTabRoute: AuthedClinicsClinicIdTabRoute,
  AuthedClinicsClinicIdIndexRoute: AuthedClinicsClinicIdIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  NoAccessRoute: NoAccessRoute,
  SetPasswordRoute: SetPasswordRoute,
  SignInRoute: SignInRoute,
  AuthActionRoute: AuthActionRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
